import { ViewStream } from "spyne";

export class PageHomeCallout extends ViewStream {
  constructor(props = {}) {
    props.class = "callout callout-home";
    props.template = require("./templates/page-home-callouts.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    const isInternal = this.props.data.links !== undefined;
    return isInternal ? [["a", "click"]] : [];
  }

  onRendered() {}
}
